var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlexible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_2390)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_80_2390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 6.625C10.0887 6.625 9.50812 6.625 9.02228 6.70194C6.34795 7.12552 4.25052 9.22296 3.82695 11.8972C3.75 12.3832 3.75 12.9638 3.75 14.125V16.625C3.75 20.1253 3.75 21.8755 4.43121 23.2124C5.03042 24.3885 5.98655 25.3446 7.16256 25.9438C8.49951 26.625 10.2497 26.625 13.75 26.625H16.25C19.7503 26.625 21.5005 26.625 22.8374 25.9438C24.0135 25.3446 24.9696 24.3885 25.5688 23.2124C26.25 21.8755 26.25 20.1253 26.25 16.625V14.125C26.25 12.9638 26.25 12.3832 26.173 11.8972C25.7495 9.22296 23.652 7.12552 20.9777 6.70194C20.4919 6.625 19.9113 6.625 18.75 6.625M11.25 6.625V8.5M11.25 6.625V4.125M11.25 6.625H18.75M18.75 6.625V4.125M18.75 6.625V8.5",
    stroke: "#003588",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 17.2495L12.4528 19.4254C12.7818 19.8171 12.9463 20.013 13.1584 20.0571C13.2266 20.0714 13.2967 20.074 13.3657 20.0651C13.5805 20.0373 13.7595 19.8546 14.1177 19.4892L19.3751 14.1245",
    stroke: "#003588",
    strokeWidth: 1.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_2390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_80_2390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlexible);
export default __webpack_public_path__ + "static/media/flexible.4a24568342d23c9e1e5450924cee221f.svg";
export { ForwardRef as ReactComponent };